import React, { useState } from 'react';
import api from '../services/api';
import './Login.css';

function Login({ onLoginSuccess }) {
  const [companyID, setCompanyID] = useState('codesquad'); // pre‑fill or let user choose
  const [employeeNo, setEmployeeNo] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await api.login({ companyID, employeeNo, password });
      if (response.data.employeeNo) {
        // Store user info in localStorage
        localStorage.setItem('employeeNo', response.data.employeeNo);
        localStorage.setItem('employeeName', response.data.employeeName);
        localStorage.setItem('companyID', response.data.companyID);
        localStorage.setItem('level', response.data.level);
        onLoginSuccess({ employeeName: response.data.employeeName });
      } else {
        setError('Login failed – no user data returned');
      }
    } catch (err) {
      console.error(err);
      setError(err.response?.data?.error || 'Invalid credentials or server error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <form onSubmit={handleSubmit} className="login-form">
        <h2>Sales Order Login</h2>
        <div className="form-group">
          <label>Company ID</label>
          <input
            type="text"
            value={companyID}
            onChange={(e) => setCompanyID(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label>Employee Number</label>
          <input
            type="text"
            value={employeeNo}
            onChange={(e) => setEmployeeNo(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label>Password</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        {error && <div className="error-message">{error}</div>}
        <button type="submit" disabled={loading}>
          {loading ? 'Logging in...' : 'Login'}
        </button>
      </form>
    </div>
  );
}

export default Login;